'use client';

import { c as _c } from "react/compiler-runtime";
import { std } from '@funkey/shared/utils';
import { cx } from 'class-variance-authority';
import Link from 'next/link';
import { useParams, usePathname, useSearchParams } from 'next/navigation';
import { TRANSLATION_MAP } from './shared';
import { I18N_CONF, ParsedLocale } from '@funkey/locales/config';
import { UrlPath } from '~/utils/routing';
const LanguageSelectByURL: React.FC<{
  onChange?(language: I18N_CONF.Language): void;
}> = props => {
  const $ = _c(4);
  const params = useParams();
  const locale = ParsedLocale.fromLocale(params.locale);
  const pathname = usePathname();
  const t0 = useSearchParams();
  let t1;
  if ($[0] !== t0) {
    t1 = t0.toString();
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const search = t1;
  const path = new UrlPath(pathname);
  if (!I18N_CONF.isValidLocale(path.segments[0] ?? "") && !I18N_CONF.LANGUAGES.includes(path.segments[0] as I18N_CONF.Language)) {
    path.unshift(locale.language);
  }
  const t2 = "@container w-full";
  const t3 = "@md:rounded-5xl @max-md:flex-col flex overflow-hidden rounded-md border";
  const t4 = std.Object.keys(TRANSLATION_MAP).map((lang, i) => {
    const config = TRANSLATION_MAP[lang];
    const Icon = config.icon;
    return <li className={cx("flex-1", i !== 0 && "@max-md:border-t @md:border-l")} key={lang}><Link href={(() => {
        const base = path.copy().setSegment(0, lang).toString();
        return search ? `${base}?${search}` : base;
      })()} onClick={() => props.onChange?.(lang)} className={cx("@md:px-7 flex h-12 flex-1 items-center gap-3 px-4 text-sm transition", "hover:bg-secondary/10", "@max-md:px-8", locale.language === lang ? "bg-secondary/20 font-medium text-primary" : "border-transparent text-primary")}><Icon className="size-5" />{config.label}</Link></li>;
  });
  let t5;
  if ($[2] !== t4) {
    t5 = <div className={t2}><ul className={t3}>{t4}</ul></div>;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  return t5;
};
export default LanguageSelectByURL;